module.exports = __webpack_public_path__ + "static/media/sr-drive-system-icon.b626f87e.png";